<div class="modal-header">
    <h4 class="modal-title">{{ cookieOptions.title }}</h4>
</div>
<div class="modal-body" *ngIf="!showPolicy">
    <p>{{ cookieOptions.message }}</p>
    <p style="cursor:pointer;" class="btn btn-secondary" (click)="showcookiepolicy()">
        {{ cookieOptions.extrainfo }}
    </p>
</div>
<div class="modal-body" *ngIf="showPolicy">
    <p>
        {{ cookieOptions.cookiepolicymessage }}
    </p>
    <p style="cursor:pointer;" class="btn btn-secondary" (click)="back()">
        {{ cookieOptions.goback }}
    </p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">
        {{ cookieOptions.acceptcookies }}
    </button>
</div>